let appendedTabs = {};
let fetchingData = {};
let tabSlider;
let firstTabClicked = true;

if ($(window).width() <= 749) {
  $('.collection_tabs_mobile_btn .tab-dropdown').click(function(){
    $(this).toggleClass('active-tab-dropdown');
    $(this).next().slideToggle();
  })
}

$(document).on('click', '#collection-tabs-nav li', function(){
  $(this).addClass("active").siblings().removeClass("active");
  const activeTab =  $(this).data("tab");
  const isTabName = $(this).data('tab-name');
  tabContent($(this))
  if ($(window).width() <= 749) {
    $('.tabs_accordion_mobile_btn').html(isTabName);
    $('#collection-tabs-nav').slideToggle();
     $('.collection_tabs_mobile_btn .tab-dropdown').toggleClass('active-tab-dropdown');
  }
  $(`.tabs-content_wrap`).removeClass('is-active');
  $(`.tabs-content_wrap[data-tab="${activeTab}"]`).addClass('is-active') 
});

function tabContent(_this) {
  const activeTab = _this.data("tab");
  const getCollection = _this.data("collection");
  const getProductLimit = _this.data("product-limit");
  const getLayout = _this.data("layout");
  const getDesktopClass = _this.data("desktop-class");
  const getMobileClass = _this.data("mobile-class");
  const getTabName = _this.data("tab-name");

  if (!appendedTabs[activeTab]) {
    if (!fetchingData[activeTab]) {
      fetchData(getCollection, activeTab)
        .then((data) => {
          newSetHtml(
            data,
            activeTab,
            getCollection,
            getProductLimit,
            getLayout,
            getDesktopClass,
            getMobileClass,
            getTabName
          );
          appendedTabs[activeTab] = true; // Mark tab as appended
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }
}

function fetchData(getCollection, activeTab) {
  fetchingData[activeTab] = true;
  const loader = document.getElementById("loader");
  loader.style.display = "block";
  $('.tabs-content_wrap .product-grid.contains-card').hide();
  $(".tab-contents .swiper-button-next").hide();
  $(".tab-contents .swiper-button-prev").hide();

  return fetch(`${getCollection}?view=collection-tab`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((data) => {
      loader.style.display = "none";
      $('.tabs-content_wrap .product-grid.contains-card').show();
      $(".tab-contents .swiper-button-next").show();
      $(".tab-contents .swiper-button-prev").show();
      return data;
    })
    .catch((error) => {
      loader.style.display = "none";
      throw error;
    });
}

function newSetHtml(
  data,
  activeTab,
  activeCollection,
  maxLiCount,
  viewMode,
  getDesktopClass,
  getMobileClass,
  getTabName
) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, "text/html");
  const tabHtml = doc.querySelectorAll(".tabs-content_wrap");
  const collectionTabContent = document.querySelector(
    ".collection-tab-content"
  );

  // Clear existing content of the tab
  if (firstTabClicked) {
    collectionTabContent.innerHTML = '';
    firstTabClicked = false;
  }
  
  const wrapperDiv = document.createElement("div");
  const wrapperLi = document.createElement("li");
 
  tabHtml.forEach((html) => {
    let count = 0;
    const liElement = html.cloneNode(true);

     $(`.tabs-content_wrap`).removeClass('is-active')

    // Add data-tab attribute to keep track of the tab
    liElement.setAttribute("data-tab", activeTab);

    if (activeTab === liElement.getAttribute("data-tab")) {
      liElement.classList.add("is-active");
    }

    if (viewMode === "slider") {
      liElement
        .querySelector("slider-component")
        .classList.add("swiper-container");
      liElement
        .querySelector(".tab-contents .product-grid.contains-card")
        .classList.add("swiper-wrapper");
      const getElement = liElement.querySelectorAll(
        ".tab-contents .product-grid.contains-card li"
      );
      getElement.forEach((element) => {
        if (count < maxLiCount) {
          element.classList.add("swiper-slide");
          wrapperLi.appendChild(element);
          count++;
        }
        return false;
      });
    }
    liElement.querySelector('.tab-contents .product-grid.contains-card').innerHTML = wrapperLi.innerHTML;
    liElement.querySelector(".tabs-title").innerHTML = getTabName;
    liElement
      .querySelector(".tab-contents .product-grid.contains-card")
      .classList.add(getDesktopClass, getMobileClass);
    wrapperDiv.appendChild(liElement);
  });
  collectionTabContent.insertAdjacentHTML("beforeend", wrapperDiv.innerHTML);
  if (viewMode === "slider") appendSliderControls(collectionTabContent);
}


function appendSliderControls(collectionTabContent) {
  const ulElement = collectionTabContent.querySelector('.tabs-content_wrap.is-active ul');
    if (ulElement) {
      const paginationDiv = document.createElement('div');
      paginationDiv.className = 'swiper-pagination';
      const nextButtonDiv = document.createElement('div');
      nextButtonDiv.className = 'swiper-button-next';
      const prevButtonDiv = document.createElement('div');
      prevButtonDiv.className = 'swiper-button-prev';
  
      ulElement.insertAdjacentElement('afterend', paginationDiv);
      paginationDiv.insertAdjacentElement('afterend', nextButtonDiv);
      nextButtonDiv.insertAdjacentElement('afterend', prevButtonDiv);
      
      initTabSlider();
    } else {
      console.error("UL element not found");
    }
}

initTabSlider();
function initTabSlider() {
  tabSlider = new Swiper(".collection-tab .swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    paginationClickable: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      424: {
        slidesPerView: 2,
      },
      850: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1360: {
        slidesPerView: 5,
      },
    },
  });
}


